import { NgModule } from '@angular/core';
import { RequiresPermissionsDirective } from './requires-permissions.directive';

@NgModule({
  declarations: [RequiresPermissionsDirective],
  exports: [RequiresPermissionsDirective]
})
export class RequiresPermissionsModule {}
